import React, { useState, useEffect, useCallback, Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import pageTitle from "../../utils/pageTitle";
import NotFound from "../NotFound";
import { ADM_AREAS_DETAILS_URL } from "../../config";
import DetailPanel from "../../components/adm-areas/DetailPanel";
import MediaPanel from "../../components/adm-areas/MediaPanel";
import CorrectionPanel from "../../components/adm-areas/CorrectionPanel";
import MapPanel from "../../components/adm-areas/MapPanel";
import SubAreaPanel from "../../components/adm-areas/SubAreaPanel";
import { showErrorAlert } from "../../store/actions/alerts";
import ComponentLoader from "../../components/loader/ComponentLoader";

import makeApiRequest from "../../utils/axios/new-axios";

const useStyles = makeStyles((theme) => ({
  breadcrumb: {
    justifyContent: "center",
    flexWrap: "wrap",
    paddingLeft: "10px",
    marginTop: "20px",
  },
}));

export default function ViewAdmArea(props) {
  const dispatch = useDispatch();
  const [notFound, setNotFound] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(true); //set to true for the initial loading
  const [admDetails, setAdmDetails] = useState(null);
  const [hasChild, setHasChild] = useState(0);
  const [mapDetails, setMapdetails] = useState(null);
  const admId = props.match.params.admId;
  const classes = useStyles();

  useEffect(() => {
    pageTitle("Administrative Area");
    fetchAdmDetails(admId);
    return () => {
      // axiosInstance.cancel("Component unmounted.");
    };
    // eslint-disable-next-line
  }, []); // [] is required to make sure that it runs only once

  const fetchAdmDetails = useCallback(
    async (admId) => {
      try {
        setIsLoadingDetails(true);
        setAdmDetails(null);
        const response = await makeApiRequest({
          url: `${ADM_AREAS_DETAILS_URL.url}/${admId}`,
          method: ADM_AREAS_DETAILS_URL.method,
        });
        pageTitle(response.data.name);
        setAdmDetails(response.data);
        setHasChild(response.data.hasChild);
        setMapdetails({
          coordinates: response.data.coordinates,
          infoWindowTitle: response.data.name,
          infoWindowDetail: response.data.googlePlaceId,
        });
        setIsLoadingDetails(false);
      } catch (error) {
        setIsLoadingDetails(false);

        if (!!error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          dispatch(
            showErrorAlert(
              "Adm Details Fetch Error : " +
              (!!error.response
                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                : error.message)
            )
          );
        }
      }
    },
    [dispatch]
  );

  return (
    <Fragment>
      {!notFound ? (
        <Fragment>
          <Container className={classes.breadcrumb}>
            {!!admDetails && (
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
              >
                <Link
                  color="inherit"
                  component={RouterLink}
                  to="/adm-areas"
                  underline="none"
                >
                  Adm
                </Link>
                {!!admDetails.parent && !!admDetails.parent.country && (
                  <Link
                    color="inherit"
                    component={RouterLink}
                    to={`/adm-areas/${admDetails.parent.country.admId}`}
                    underline="none"
                  >
                    {admDetails.parent.country.name}
                  </Link>
                )}
                {!!admDetails.parent && !!admDetails.parent.adm1 && (
                  <Link
                    color="inherit"
                    component={RouterLink}
                    to={`/adm-areas/${admDetails.parent.adm1.admId}`}
                    underline="none"
                  >
                    {admDetails.parent.adm1.name}
                  </Link>
                )}
                <Typography color="textPrimary">{admDetails.name}</Typography>
              </Breadcrumbs>
            )}
          </Container>
          <Container style={{ marginTop: "20px", padding: "10px" }}>
            <ComponentLoader isLoading={isLoadingDetails} />
            {!isLoadingDetails && admDetails && (
              <Fragment>
                <DetailPanel
                  level={admDetails.type + 1}
                  admDetails={admDetails}
                  setHasChild={setHasChild}
                  setMapdetails={setMapdetails}
                />
                <MediaPanel
                  parentId={admDetails.admId}
                  medias={admDetails.media}
                />
                <CorrectionPanel
                  parentId={admDetails.admId}
                  corrections={admDetails.correction}
                />
                <MapPanel mapDetails={mapDetails} />
                {hasChild === 1 &&
                  (admDetails.type === 0 || admDetails.type === 1) ? (
                  <SubAreaPanel
                    level={admDetails.type + 1}
                    parentId={admDetails.admId}
                    countryCode={admDetails.countryCode}
                    hasChild={hasChild}
                    admType={admDetails.type}
                  />
                ) : null}
              </Fragment>
            )}
          </Container>
        </Fragment>
      ) : (
        <NotFound />
      )}
    </Fragment>
  );
}
